<template>
  <video
    ref="media"
    muted
    loop
    playsinline
    preload="metadata"
    :poster="poster || null"
    aria-hidden="true"
    tabindex="-1"
  >
    <source :src="src" type="video/mp4">
  </video>
</template>

<script>
import { bindMotionMedia } from '@/utils/journeyMotion'

export default {
  name: 'MotionMedia',
  props: {
    src: {
      type: String,
      required: true,
    },
    poster: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      stopMediaController: null,
    }
  },
  mounted() {
    this.stopMediaController = bindMotionMedia(this.$refs.media)
  },
  beforeDestroy() {
    if (this.stopMediaController) this.stopMediaController()
  },
}
</script>
